import { mapInstruments } from './mapInstruments';
import { useInstruments } from './useInstruments';

export const useTabs = () => {
  const { instruments, loading, error, refetch } = useInstruments();

  const tabs = mapInstruments(instruments);

  return {
    loading,
    tabs,
    error,
    refetch,
  };
};
